import { createSlice } from "@reduxjs/toolkit";
import { ReportInitialStore } from "./types.store";
import {
  handleGetReportDataRequest,
  handleGetDownloadXlsRequest,
} from "./thunk.store";

const initialState: ReportInitialStore = {
  data: null,
  excel: null,
};

const ReportStore = createSlice({
  initialState,
  name: "ReportData",
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(handleGetReportDataRequest.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });

    builder.addCase(handleGetDownloadXlsRequest.fulfilled, (state, action) => {
      state.excel = action.payload;
    });
  },
});

export default ReportStore.reducer;
